module.exports = __webpack_public_path__ + "img/about-me.314c7797.jpg";